/**
 * ч.843: попап «налаштувати віджети» головної — галочки складу + порядок
 * (стрілки). Вибір зберігається у профілі (uiPrefs → /ui-prefs).
 */
import uiPrefs from '@/store/uiPrefs';
import { CHECKUP_HIDDEN_KEY, useCheckupBlocks, useCheckupHidden } from './MigrationCheckupBanner';
import { WIDGETS, type WidgetDef } from './widgetRegistry';

/** ч.1411: галочка лише там, де чек-ап є що показати; сам чек-ап лишається у своєму розділі. */
function CheckupToggle() {
  const blocks = useCheckupBlocks();
  const hidden = useCheckupHidden();
  if (blocks.length === 0) return null;
  return (
    <div style={{ marginBottom: '0.7rem' }}>
      <div style={{ fontSize: '0.8rem', color: 'var(--muted)', marginBottom: '0.3rem' }}>
        Над віджетами:
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '2px 0',
        margin: 0, color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit' }}>
        <input type="checkbox" checked={!hidden} style={{ width: 'auto' }}
          onChange={() => uiPrefs.set(CHECKUP_HIDDEN_KEY, !hidden)} />
        <span>Чек-ап після міграції</span>
      </label>
    </div>
  );
}

export default function WidgetSettings({ selected, onChange, onClose, available = WIDGETS }: {
  selected: string[];
  onChange: (ids: string[]) => void;
  onClose: () => void; available?: WidgetDef[] }) {
  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };
  const move = (id: string, dir: -1 | 1) => {
    const i = selected.indexOf(id);
    const j = i + dir;
    if (i < 0 || j < 0 || j >= selected.length) return;
    const next = [...selected];
    const a = next[i]!, b = next[j]!;
    next[i] = b; next[j] = a;
    onChange(next);
  };
  // ч.1311: лише віджети, доступні ролі (решту не показуємо навіть у виборі).
  const chosen: WidgetDef[] = selected
    .map((id) => available.find((w) => w.id === id))
    .filter((w): w is WidgetDef => !!w);
  const rest = available.filter((w) => !selected.includes(w.id));

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1200,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div className="card" style={{ width: 460, maxWidth: '95vw', padding: '1rem' }}
        onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.6rem' }}>
          <h3 style={{ margin: 0 }}>Віджети головної</h3>
          <button type="button" style={{ marginLeft: 'auto' }} onClick={onClose}>закрити</button>
        </div>

        <CheckupToggle />

        <div style={{ fontSize: '0.8rem', color: 'var(--muted)', marginBottom: '0.4rem' }}>
          На екрані ({chosen.length}) — порядок стрілками:
        </div>
        {chosen.map((w, i) => (
          <div key={w.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '2px 0' }}>
            <input type="checkbox" checked onChange={() => toggle(w.id)} style={{ width: 'auto' }} />
            <span style={{ flex: 1 }}>{w.label}</span>
            <button type="button" style={{ padding: '0 0.4rem' }} disabled={i === 0}
              title="Вище" onClick={() => move(w.id, -1)}>↑</button>
            <button type="button" style={{ padding: '0 0.4rem' }} disabled={i === chosen.length - 1}
              title="Нижче" onClick={() => move(w.id, 1)}>↓</button>
          </div>
        ))}
        {chosen.length === 0 && (
          <div style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>Жодного віджета не обрано.</div>
        )}

        {rest.length > 0 && (
          <>
            <div style={{ fontSize: '0.8rem', color: 'var(--muted)', margin: '0.7rem 0 0.3rem' }}>
              Доступні:
            </div>
            {rest.map((w) => (
              <div key={w.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '2px 0' }}>
                <input type="checkbox" checked={false} onChange={() => toggle(w.id)} style={{ width: 'auto' }} />
                <span style={{ flex: 1, color: 'var(--muted)' }}>{w.label}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
